import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';

export const completeTaskEndpoint = async (teamId: string) => {
	await fetch(urls.onboarding.completeTask.url(), {
		method: 'POST',
		body: {
			platformTeamId: teamId,
			completedItemKey: 'opsgenie-review-oncall-setup',
		},
	});

	return fetch(urls.onboarding.completeTask.url(), {
		method: 'POST',
		body: {
			platformTeamId: teamId,
			completedItemKey: 'compass-oncall-setup',
		},
	});
};
